<div class="rs-padding-left3-m">
  <p id="target">
    <mprd-address [address]="address" [showInOneLine]="true"></mprd-address>
  </p>
    <ng-container *ngTemplateOutlet="pxAlert"></ng-container>
  <mprd-sports-order-button
    [buttonType]="OrderButtonType.CEASE"
    [isScarletOption]="isScarletOption"
    *ngIf="isSubscriptionActive"
  ></mprd-sports-order-button>
  <div class="rs-pickx">
    <div class="rs-ctable rs-ctable-highlight rs-margin-top2">
      <div class="rs-flex-row">
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-has-overlap rs-maxh">
            <div class="rs-panel-flex">
              <div
                class="rs-panel-flex-cell rs-bg-pickx rs-border-c2 rs-flex rs-flex-dir-col"
              >
                <div class="rs-flex-grow">
                  <h3 class="rs-ctable-panel-title rs-padding-top1">
                    {{ "option.details.sports.standard.title" | translate }}
                  </h3>
                  <ul
                    [innerHtml]="
                      'option.details.sports.standard.content' | translate
                    "
                  ></ul>
                </div>
                <div
                  [innerHtml]="
                    'option.details.sports.standard.promoContent'
                      | translate
                      | safeHtml
                  "
                  *ngIf="
                    ('option.details.sports.standard.promoContent'
                      | translate) !== ' '
                  "
                ></div>
                <p
                  class="text-center"
                  [innerHtml]="
                    'option.details.sports.standard.priceContent' | translate
                  "
                ></p>
                <div
                  class="rs-padding1"
                  *ngIf="isSubscriptionActive && !isPremiumPlanActive"
                >
                  <p class="rs-status rs-success rs-justify-center">
                    <i class="rs-status-icon" aria-hidden="true"></i> {{ "option.details.sports.active" | translate }}
                  </p>
                </div>
                <mprd-sports-order-button
                  [buttonType]="OrderButtonType.ORDER_STANDARD"
                  [isScarletOption]="isScarletOption"
                  *ngIf="!isSubscriptionActive"
                ></mprd-sports-order-button>
                <mprd-sports-order-button
                  [buttonType]="OrderButtonType.DOWNGRADE"
                  [isScarletOption]="isScarletOption"
                  *ngIf="isPremiumPlanActive"
                ></mprd-sports-order-button>
              </div>
            </div>
          </div>
        </div>
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-has-overlap rs-maxh">
            <div class="rs-panel-flex">
              <div
                class="rs-panel-flex-cell rs-bg-pickx rs-border-c2 rs-flex rs-flex-dir-col"
              >
                <div
                  class="rs-patch-recommended rs-patch-recommended-full-so rs-patch-recommended-full-m rs-is-overlapping"
                >
                  <div class="rs-patch-content">
                    {{
                      "option.details.sports.premium.recommended" | translate
                    }}
                  </div>
                </div>
                <div class="rs-flex-grow">
                  <h3 class="rs-ctable-panel-title rs-padding-top1">
                    {{ "option.details.sports.premium.title" | translate }}
                  </h3>
                  <ul
                    [innerHtml]="
                      'option.details.sports.premium.content' | translate
                    "
                  ></ul>
                </div>

                <div
                  [innerHtml]="
                    'option.details.sports.premium.promoContent'
                      | translate
                      | safeHtml
                  "
                  *ngIf="
                    ('option.details.sports.premium.promoContent'
                      | translate) !== ' '
                  "
                ></div>
                <p
                  class="text-center"
                  [innerHtml]="
                    'option.details.sports.premium.priceContent' | translate
                  "
                ></p>

                <div class="rs-padding1" *ngIf="isPremiumPlanActive">
                  <p class="rs-status rs-success rs-justify-center">
                    <i class="rs-status-icon" aria-hidden="true"></i>{{ "option.details.sports.active" | translate }}
                  </p>
                </div>
                <mprd-sports-order-button
                  [buttonType]="OrderButtonType.ORDER_PREMIUM"
                  [isScarletOption]="isScarletOption"
                  *ngIf="!isSubscriptionActive"
                ></mprd-sports-order-button>
                <mprd-sports-order-button
                  [buttonType]="OrderButtonType.UPGRADE"
                  [isScarletOption]="isScarletOption"
                  *ngIf="isSubscriptionActive && !isPremiumPlanActive"
                ></mprd-sports-order-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p class="rs-txt-s3">
    {{ "option.details.sports.orderDesclaimer" | translate }}
  </p>
</div>
<hr class="rs-hr-white show-for-small-only" />

<ng-template #pxAlert>
  <px-alert *ngIf="alertKey" [alertKey]="alertKey"></px-alert>
</ng-template>
